
import { getCookie } from 'cookies-next';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getFilteredProjects = async (filters, email = null) => {
    let currencyValue = getCookie('currency')
    let localeValue = getCookie('NEXT_LOCALE')
    // console.log(currencyValue)

    const { name, bts, project, category, room, minBedrooms, maxBedrooms, page, limit = 8, currency, minprice, maxprice, petfriendly, seaview, beachfront, newdevelopment, map, sort, district, districts, location } = filters
    // console.log(filters)
    const url = `${baseUrl}/projects/projectswithlistings?name=${name}&bts=${bts}&location=${location}&district=${district}&districts=${districts}&category=${category}&petfriendly=${petfriendly}&seaview=${seaview}&beachfront=${beachfront}&newdevelopment=${newdevelopment}&map=${map}&limit=${limit}&page=${page}&sort=${sort}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'email': email,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        cache: 'no-store',
        // next: { revalidate: 1800 } // 30m
    })

    const result = await response.json()


    const id = getCookie('id')
    const likes = getCookie('likes')
    // if (id == undefined && likes !== undefined && likes.length > 0 && result.properties.length > 0) {
    //     // console.log('has likes')
    //     result.properties.forEach(property => {
    //         if (likes.includes(property.id)) {
    //             property.isLiked = true
    //         }
    //     })
    // }

    return result

}